import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

import Layout from 'app/components/Layout';
import { ModalInfoErrorPage } from 'app/components/ModalInfoErrorPage';
import { setModalErrorClose } from 'app/domain/loan/slice';
import selectLoanState from 'app/domain/loan/slice/selectors';
import selectProfileState from 'app/domain/profile/slice/selectors';
import { RoutePath } from 'app/Routing/constants';

const withLayout = (Component: React.ComponentType, backURL?: string) => () => {
  const {
    redirect: { isFromFinalEdit },
    skip_liveness,
    skip_ktp,
  } = useSelector(selectLoanState);
  const { applicationId, isDigitalApplication } =
    useSelector(selectProfileState);
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  if (
    (isDigitalApplication && location.pathname === RoutePath.vehicleDetail) ||
    (!skip_liveness &&
      skip_ktp &&
      (location.pathname === RoutePath.takeSelfieOnly ||
        location.pathname === RoutePath.verifyIdentityPage))
  ) {
    backURL = undefined;
  } else if (
    isFromFinalEdit.length > 0 &&
    location.pathname !== RoutePath.reviewApplication &&
    location.pathname !== RoutePath.loanEstimation &&
    backURL !== 'back'
  ) {
    backURL = isFromFinalEdit[isFromFinalEdit.length - 1];
  }
  useEffect(() => {
    if (
      location.pathname !== RoutePath.landingPage &&
      location.pathname !== RoutePath.otpVerification &&
      !applicationId
    ) {
      navigate(RoutePath.applicationIdErrorPage);
    }
  }, [applicationId, location.pathname, navigate]);

  useEffect(() => {
    dispatch(setModalErrorClose());
  }, [dispatch]);

  return (
    <>
      <Layout backURL={backURL}>
        <Component />
        <ModalInfoErrorPage />
      </Layout>
    </>
  );
};

export default withLayout;
